import { Button } from "@mui/material";
import React from "react";

function TabChartFilter({ tabHandler, chartFilter, name }) {
  const ChartName = [
    "Customer",
    "Production",
    "Designer",
    "Order",
    "Production",
    "AccountTransfer",
  ];
  return (
    <>
      <InitialButtonFilter
        chartFilter={chartFilter}
        keyValue={"day"}
        tabHandler={tabHandler}
        label={"روز"}
        borderRadius={"8px 0px 0px 8px"}
      />
      <InitialButtonFilter
        chartFilter={chartFilter}
        keyValue={"mondth"}
        tabHandler={tabHandler}
        label={"ماه"}
        borderRadius={"0px 0px 0px 0px"}
      />
      <InitialButtonFilter
        chartFilter={chartFilter}
        keyValue={"year"}
        tabHandler={tabHandler}
        label={"سال"}
        borderRadius={
          ChartName.includes(name) ? "0px 0px 0px 0px" : "0px 8px 8px 0px"
        }
      />
      {ChartName.includes(name) && (
        <InitialButtonFilter
          chartFilter={chartFilter}
          keyValue={"all"}
          tabHandler={tabHandler}
          label={"کل"}
          borderRadius={"0 8px 8px 0px"}
        />
      )}
    </>
  );
}

export default TabChartFilter;

const InitialButtonFilter = ({
  chartFilter,
  keyValue,
  tabHandler,
  label,
  borderRadius,
}) => {
  return (
    <Button
      onClick={() => tabHandler(keyValue)}
      sx={{
        width: "2rem",
        background:
          chartFilter.name === keyValue ? "rgba(30, 106, 253, 1)" : "",
        color: chartFilter.name === keyValue ? "#fff" : "rgba(30, 106, 253, 1)",
        borderRadius: borderRadius,
        border: "1px solid rgba(30, 106, 253, 1)",
      }}
    >
      {label}
    </Button>
  );
};
